import { Loader, SelectPicker, Tooltip, Whisper } from "rsuite";
import ProductInfoIcon from "../../assets/info-circle-grey.svg";
import KPICard from "../../components/kpi-card";
import ModuleCard from "../../components/module-card";
import {
  KPI,
  KPIInfo,
  ModuleData,
  ModuleInfo,
} from "../../services/interfaces/IHomePage";
import { useEffect, useState } from "react";
import { CheckPicker } from "rsuite";
import { useHomeData, useHomeFilters } from "../../react-query/hooks/HHomePage";
import { CD_Routes, KPI_Name, Module_Name } from "../../utils/constants";
import useResponsiveWidth from "../../react-query/hooks/useResponsiveWidth";
import { useAppSelector } from "../../services/redux/hooks/hooks";
import { sortCommodityFirst, getDefaultCommodity } from "../../utils/helpers/commodityOrder";

const Home = ({ setHomeData }: any) => {
  const userModuleData = useAppSelector((state) => state.user.userModuleArray);
  const width = useResponsiveWidth();
  const userDetailsRedux = useAppSelector((state) => state.user);
  const isDimUser = Boolean(userDetailsRedux?.role_name === "DIM");
  const [commodity, setCommodity] = useState<null | string>(null);
  const [jpToggle, setJpToggle] = useState<"JPIN" | "JPOUT">("JPIN");
  const showHomeExclusionFilter =
    (commodity ?? "").trim().toLowerCase() === "copper wire";
  const [district, setDistrict] = useState<Array<string> | null>(null);
  const [updatedDistricts, setUpdatedDistricts] =
    useState<Array<string> | null>(null);
  const { fetchFilters: filters, isLoading } = useHomeFilters(
    localStorage.getItem("userEmail")
  );
  const { data: homeData, isLoading: modulesLoading } = useHomeData(
    localStorage.getItem("userEmail"),
    commodity,
    updatedDistricts?.length
      ? updatedDistricts
      : filters?.districts && filters.districts.length
        ? filters.districts.map((ele) => ele.district)
        : null,
    true,
    jpToggle === "JPIN" ? 1 : 0
  );
  const [username, setUsername] = useState(localStorage?.getItem("name"));
  const [kpiInfo, setKpiInfo] = useState<{
    spend: KPIInfo[];
    volume: KPIInfo[];
    sales: KPIInfo[];
    transactionMargin: KPIInfo[];
  }>({ spend: [], volume: [], sales: [], transactionMargin: [] });
  const [modulesInfo, setModulesInfo] = useState<ModuleInfo[] | null>(null);

  useEffect(() => {
    if (Object.keys(filters).length > 0 && commodity === null) {
      setCommodity(getDefaultCommodity(filters.commodity) ?? null);
    }
  }, [filters]);

  useEffect(() => {
    if (homeData && Object.keys(homeData).length > 0) {
      let kpiData = Object.keys(homeData.kpi).map((entity: string) => {
        return {
          kpi: entity,
          title: KPI_Name[entity as keyof typeof KPI_Name],
          unit:
            entity.includes("yoy") || entity.includes("ytd_tm")
              ? "%"
              : entity === "ytd_volume"
                ? "lbs"
                : "$",
          value: homeData.kpi[entity as keyof KPI],
        };
      });

      let filteredmoduleData: ModuleInfo[] | any = homeData.data.filter(
        (module: ModuleData) => {
          if (
            (module.name === "upcoming_negotiations" &&
              [
                "Vendor Quote Assessment",
                "Volumne Allocation",
                "Allocation Summary",
              ].some((module) => userModuleData.includes(module))) ||
            (module.name === "business_cost" &&
              userModuleData.includes("Board Cost Setting")) ||
            (module.name === "compliance_monitoring" &&
              ["Cost Complaince", "Volume Complaince"].some((module) =>
                userModuleData.includes(module)
              )) ||
            (module.name === "nia_opportunity" &&
              userModuleData.includes("NIA Opportunity"))
          ) {
            return true;
          } else {
            return false;
          }
        }
      );

      const dimExcludedModules = ["upcoming_negotiations", "business_cost"];

      let moduleData: ModuleInfo[] = filteredmoduleData
        .filter(
          (module: ModuleData) =>
            !(isDimUser && dimExcludedModules.includes(module.name))
        )
        .map((module: ModuleData) => ({
          id: module.name,
          name: Module_Name[module.name as keyof typeof Module_Name],
          opportunity: module.opportunity,
          days_left_for_review: module.days_left_for_review,
          route: CD_Routes[module.name as keyof typeof CD_Routes],
          districts_reviewed_x: module.districts_reviewed_x,
          total_districts_y: module.total_districts_y,
          recommendation: module.recommendation,
          count_vendors_exceeding_commitment:
            module.count_vendors_exceeding_commitment ?? [],
          total_districts: module.total_districts ?? null,
          minPercentage:
            module.min_overpayment_percentage ?? module.min_opportunity ?? 0,
          maxPercentage:
            module.max_overpayment_percentage ?? module.max_opportunity ?? 0,
          total_districts_commitment:
            module?.districts_with_overpayments_count ?? 0,
          total_vendors: module?.vendor_count ?? 0,
        }));

      let reInitializeEmpty: {
        spend: KPIInfo[];
        volume: KPIInfo[];
        sales: KPIInfo[];
        transactionMargin: KPIInfo[];
      } = { spend: [], volume: [], sales: [], transactionMargin: [] };
      /* To incorporate two kpi's in single card */
      let updatedKPI = kpiData.reduce(
        (acc, eachKpi: KPIInfo) => {
          if (eachKpi.kpi.includes("spend")) {
            acc.spend = [...acc.spend, eachKpi];
          } else if (eachKpi.kpi.includes("sales")) {
            acc.sales = [...acc.sales, eachKpi];
          } else if (eachKpi.kpi.includes("volume")) {
            acc.volume = [...acc.volume, eachKpi];
          } else if (eachKpi.kpi.includes("tm")) {
            acc.transactionMargin = [...acc.transactionMargin, eachKpi];
          }
          return acc;
        },
        {
          sales: reInitializeEmpty?.sales,
          volume: reInitializeEmpty?.volume,
          spend: reInitializeEmpty?.spend,
          transactionMargin: reInitializeEmpty?.transactionMargin,
        }
      );
      setKpiInfo(updatedKPI);
      setModulesInfo(moduleData);
      console.log(moduleData)
      setHomeData(homeData)
    }
  }, [homeData]);

  useEffect(() => {
    if (!showHomeExclusionFilter && jpToggle !== "JPIN") {
      setJpToggle("JPIN");
    }
  }, [showHomeExclusionFilter, jpToggle]);


  return (
    <>
      {isLoading || modulesLoading ? (
        <Loader
          backdrop
          content="Loading..."
          size="md"
          vertical
          className="text-black font-bold"
          style={{ opacity: 0.6 }}
        />
      ) : (
        <div className="flex flex-col justify-stretch items-stretch h-full home-page">
          <div className="h-[38%] ps-[3%] pr-[5%] pt-[3%] pb-[2%] flex flex-col flex-nowrap justify-start items-start gap-6 shadow-normal">
            <div className="flex justify-between items-center w-full">
              <div className="font-normal text-[2vw]">
                Welcome&nbsp;
                <span className="font-bold text-[2vw] text-deloitteGreen">
                  {username}
                </span>
              </div>
              <div className="flex justify-start items-center gap-8">
                <div className="flex flex-col justify-start items-start">
                  <label className="font-bold text-[0.9vw]">Commodity</label>
                  <SelectPicker
                    data={sortCommodityFirst(filters.commodity)}
                    value={commodity ?? getDefaultCommodity(filters.commodity)}
                    labelKey="commodity"
                    valueKey="commodity"
                    style={{ width: width }}
                    onChange={(value: string | null) => {
                      setCommodity(value);
                    }}
                    placeholder="All"
                    cleanable={false}
                  ></SelectPicker>
                </div>

                <div className="flex flex-col justify-start items-start max-w-[max(180px,10vw)]">
                  <label className="font-bold text-[0.9vw]">District</label>
                  <CheckPicker
                    data={filters.districts}
                    value={district ?? []}
                    preventOverflow={true}
                    onChange={(value: string[]) => setDistrict(value)}
                    placeholder="All"
                    labelKey="district"
                    style={{ width: width }}
                    valueKey="district"
                    onClean={() => {
                      setUpdatedDistricts(null);
                    }}
                    onClose={() => setUpdatedDistricts(district)}
                  />
                </div>

                {showHomeExclusionFilter && (
                  <div className="flex flex-col justify-start items-start">
                    <label className="font-bold text-[0.9vw]">
                      Proj. through Stock
                    </label>
                    <SelectPicker
                      data={[
                        { label: "Exclude", value: "JPIN" },
                        { label: "Include", value: "JPOUT" },
                      ]}
                      value={jpToggle}
                      onChange={(value: string | null) => {
                        if (value) setJpToggle(value as "JPIN" | "JPOUT");
                      }}
                      style={{ width: width }}
                      cleanable={false}
                      searchable={false}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="flex justify-start items-center w-full h-full gap-4">
              {kpiInfo.sales.length > 0 &&
                Object.keys(kpiInfo).map((kpi: string, index: number) => {
                  return (
                    <KPICard
                      refreshed_date={homeData?.date[0]?.refreshed_date}
                      key={index}
                      kpi={kpiInfo[kpi as "spend" | "volume" | "sales"]}
                    ></KPICard>
                  );
                })}
            </div>
          </div>

          <div
            className={`bg-[#F1F1F1] pl-[3%] py-[3%] pr-[5%] flex ${modulesInfo?.length === 1 ? "justify-center" : "justify-between"
              } items-center gap-8 h-[62%]`}
          >
            {modulesInfo &&
              modulesInfo.map((item: ModuleInfo) => {
                return (
                  <ModuleCard
                    length={modulesInfo.length}
                    key={item.id}
                    module={item}
                    date={homeData?.date[0].month_year}
                    filter={district || []}
                  ></ModuleCard>
                );
              })}
          </div>
        </div>
      )}
    </>
  );
};
export default Home;
